import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Registrá las marcas de los repuestos que comprás, tanto originales como alternativas.',
    'No mezclar con las marcas de equipos: son listas independientes.',
    'Cargar la marca en cada repuesto permite comparar después la duración entre marcas distintas.',
  ],
  nextSteps: [
    'Asignar la marca a cada repuesto del catálogo.',
    'Consultar el informe de durabilidad de repuestos para evaluar el rendimiento de cada marca.',
  ],
};

const ConfiguracionMarcasRepuesto = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="marcas-repuesto"
      titulo="Marcas de Repuesto"
      descripcion="Marcas de repuestos y componentes"
      icon="fas fa-industry"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionMarcasRepuesto;
